/* global windowWidth, breakpointMd */

const toggleFilterList = (toggle) => {
  if (windowWidth() < breakpointMd) {
    const filterList = document.querySelector('.product-results__filter');
    filterList.classList.toggle('is-open', toggle);
    toggleBodyScrollLock(toggle);
  }
};

// ------
// Open filter
// ------

attachEvent('.product-results__filter-title', 'click', (ev) => {
  toggleFilterList(true);
});

// ------
// Close filter
// ------

attachEvent('.product-results__filter-close', 'click', (ev) => {
  toggleFilterList(false);
});

attachEvent('.product-results__filter-item-checkbox input', 'click', (ev) => {
  const productResults = document.querySelector('.product-results');
  const categories = [];
  if (productResults) {
    productResults.querySelectorAll('.product-results__filter-item-list').forEach((item) => {
      const categorySection = [];
      item.querySelectorAll('.product-results__filter-item-checkbox input').forEach((item2) => {
        if (item2.checked) {
          categorySection.push(item2.id);
        }
      });
      if (categorySection.length > 0) {
        categories.push(categorySection.join(','));
      }
    });
    axios
      .get(localData.siteURL, {
        params: {
          action: 'getProductResults',
          id: localData.id,
          lang: localData.lang,
          categories: categories.join('|'),
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          window.history.pushState({ urlPath: window.location.href }, null, `?categories=${categories.join('|')}`);
          const productResultsList = productResults.querySelector('.product-results__list');
          const productResultsNoResults = productResults.querySelector('.no-results');
          if (response.data.data.newHTML) {
            productResultsList.innerHTML = response.data.data.newHTML;
            productResultsNoResults.classList.add('hide');
          } else {
            productResultsNoResults.classList.remove('hide');
            productResultsList.innerHTML = '';
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
});

// ------
// Add parameters to link
// ------

if (document.querySelector('.wizard-module__footer-right a')) {
  const buttonSearch = document.querySelector('.wizard-module__footer-right a');
  buttonSearch.addEventListener('click', (ev) => {
    ev.preventDefault();
    const wizardModule = document.querySelector('.wizard-module');
    const categories = [];
    if (wizardModule) {
      // eslint-disable-next-line array-callback-return
      Array.from(wizardModule.querySelectorAll('input')).map((item) => {
        if (item.checked) {
          categories.push(item.id.replace(/\D/g,''));
        }
      });
    }
    if (categories) {
      const link = buttonSearch.href;
      if (link) {
        // eslint-disable-next-line no-param-reassign
        window.location = `${link}?categories=${categories.join('|')}`;
      }
    }
  });
}

